<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout justify-center wrap>

            <!---검색--->
            <v-flex md12>
                <v-form>
                    <v-container fill-height fluid grid-list-xl>
                        <v-layout wrap style="background: #fff;" class="borderTop ">
                            <v-flex md1 xs2 class="conTh py-2 borderBottom borderRight">유저ID</v-flex>
                            <v-flex md3 xs4  class="py-2 borderBottom borderRight">
                                <v-text-field
                                        v-model="search_condition.user_id"
                                        label="유저ID"
                                        solo
                                        hide-details
                                        flat
                                        @keyup.enter="searchList()">
                                ></v-text-field>
                            </v-flex>

                            <v-flex md1 xs2 class="conTh py-2 borderBottom borderRight">닉네임</v-flex>
                            <v-flex md3 xs4 class="py-2 borderBottom borderRight">
                                <v-text-field
                                        v-model="search_condition.nickname"
                                        label="닉네임"
                                        solo
                                        hide-details
                                        flat
                                        @keyup.enter="searchList()">
                                ></v-text-field>
                            </v-flex>

                            <v-flex md1 xs2 class="conTh py-2 borderBottom borderRight">SNS타입</v-flex>
                            <v-flex md3 xs4 class="py-2 borderBottom borderRight">
                                <v-select
                                        v-model="search_condition.sns_type"
                                        :items="OPTIONS_SNS_TYPE"
                                        label="전체"
                                        flat
                                        hide-details
                                        solo
                                ></v-select>
                            </v-flex>
                            <v-flex md1 xs2 class="conTh py-2 borderBottom borderRight">등급</v-flex>
                            <v-flex md3 xs4 class="py-2 borderBottom borderRight">
                                <v-select
                                        v-model="search_condition.type"
                                        :items="OPTIONS_MEMBER_TYPE.slice(0,OPTIONS_MEMBER_TYPE.length)"
                                        label="전체"
                                        flat
                                        hide-details
                                        solo
                                ></v-select>
                            </v-flex>

                            <v-flex md1 xs2 class="conTh py-2 borderBottom borderRight">이메일</v-flex>
                            <v-flex md3 xs4 class="py-2 borderBottom borderRight">
                                <v-text-field
                                        v-model="search_condition.email"
                                        label="이메일"
                                        solo
                                        hide-details
                                        flat
                                        @keyup.enter="searchList()">
                                ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs6 class=" py-2 borderBottom borderRight"> </v-flex>
                            <v-flex md1 xs2 class="conTh py-2 borderBottom borderRight">가입일</v-flex>
                            <v-flex md7 xs10 class="py-2 borderBottom ">
                                <DatePicker v-model="selection_period" ref="datepick"></DatePicker>
                            </v-flex>

                            <v-flex md4 class=" py-2 borderBottom borderRight"></v-flex>


                            <v-flex xs12 text-xs-center  class=" py-2  ">
                                <v-btn class="mx-0 mr-1 " color="primary" outline style="width:150px;" @click="resetList()">초기화</v-btn>
                                <v-btn class="mx-0 " color="primary" style="width:150px;" @click="searchList()">검색</v-btn>

                            </v-flex>

                        </v-layout>
                    </v-container>
                </v-form>

            </v-flex>
            <!---검색--->


            <!-- 검색결과 --->
            <v-flex md12 pt-0>
                <v-data-table
                        :headers="HEADERS_MEMBER.slice(1,HEADERS_MEMBER.length)"
                        :items="items"
                        :pagination.sync="pagination"
                        item-key="id"
                        class="dataTable"
                >
                    <template slot="headers" slot-scope="props">
                        <tr>
                            <th
                                    v-for="header in props.headers"
                                    :key="header.text"
                                    :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                                    @click="changeSort(header.value)"
                            >
                                {{ header.text }}
                            </th>
                        </tr>
                    </template>

                    <template slot="items" slot-scope="props">
                        <tr style="cursor: pointer"  @click="selectRow(props.item)">
                            <td class="text-xs-center" width="10%">{{ TYPE_MEMBER_TYPE[props.item.type]}}</td>
                            <td class="text-xs-center" width="5%">{{ props.item.sns_type }}</td>
                            <td class="text-xs-center" width="15%">{{ props.item.nickname }}</td>
                            <td class="text-xs-center" width="15%">{{ props.item.email }}</td>
                            <td class="text-xs-center" width="12%">{{ props.item.created_at |time}}</td>
                            <td class="text-xs-center" width="12%">{{ props.item.updated_at |time }}</td>
                        </tr>

                    </template>
                </v-data-table>

            </v-flex>
            <v-flex md12 class="text-xs-center">
                <v-pagination v-model="pagination.page" :length="pages" :total-visible="10"></v-pagination>
            </v-flex>
            <!-- 검색결과 --->

        </v-layout>
    </v-container>
</template>


<script>
	import MyMixinCommon from '../../mixins/MyMixinCommon';
	import MyMixinList from '../../mixins/MyMixinList'
	import DatePicker from '../../components/DatePicker.vue'
	import { mapActions, mapGetters } from 'vuex'
	import * as userApi from '../../service/api/user-api'


	export default {
		mixins: [ MyMixinCommon, MyMixinList ],
		components: {
			DatePicker,

		},
		data: () => ({

			pagination: {},
			headers: [],

			total: 0,
			serverData: [],
			items: [],

			search_condition :{
				user_id :null,
				type :null,
				sns_type :null,
				sns_id :null,
				refresh_token :null,
				nickname :null,
				email :null,
				created_at :null,
				updated_at :null,
				deleted_at :null,
			},

		}),
		computed: {
            pages() {
                if( this.pagination.rowsPerPage == null) {
                    return 0
                }

                return Math.ceil( this.items.length / this.pagination.rowsPerPage )
            }

		},
		watch: {
			// 라우트가 변경되면 메소드를 다시 호출합니다
			'$route': 'init',
		},
		created() {

		},
		methods: {
			...mapGetters( 'user', [ 'getUserId','getLoginType' ] ),

			/////////////////////////////////////////////////// INIT /////////////////////////////////////////////////////////
			permissionCheck(){
				if(Number(this.getLoginType())  >= 3) {


					this.resetInfo()
					this.initList()
				}else{

					this.$dialog.alert('관리자 권한이 없어 메인페이지로 이동합니다.').then(dialog=>{
						this.$router.push( 'contents' )
					})

				}

			},

			/////////////////////////////////////////////////// FUNC /////////////////////////////////////////////////////////

			init() {

				this.permissionCheck()



			},

			initList(){

				let req = this.search_condition

				if (req != null) {
					Object.keys(req).forEach((key) => (req[key] == null || req[key] == '') && delete req[key])
				}
				this.reqList(req)
			},
			resetInfo() {
				this.selection_period.from = null
				this.selection_period.to = null
				this.selection_period.toggle = 0

				Object.keys(this.search_condition).forEach((key) => {
					this.search_condition[key] = null
				})
			},
			resetList() {
				this.resetInfo()
				this.$router.push({path: 'users'})
			},



			selectRow( item ) {

					this.$router.push( { name: 'user', params: { id: item.user_id } } );

			},
			routeCheck() {
				// ID
				if (this.$route.query.user_id) {
					this.search_condition.user_id = this.$route.query.user_id
				}

				// 닉네임
				if (this.$route.query.nickname) {
					this.search_condition.nickname = this.$route.query.nickname
				}

				// sns 타입
				if (this.$route.query.sns_type) {
					this.search_condition.sns_type = this.$route.query.sns_type
				}

				// 등급
				if (this.$route.query.type) {
					this.search_condition.type = this.$route.query.type
				}

				// 이메일
				if (this.$route.query.email) {
					this.search_condition.email = this.$route.query.email
				}

				// 등록일(from)
				if (this.$route.query.created_from) {
					this.search_condition.created_from = this.$route.query.created_from
					this.selection_period.from = this.search_condition.created_from
				}

				// 등록일(to)
				if (this.$route.query.created_to) {
					this.search_condition.created_to = this.$route.query.created_to
					this.selection_period.to = this.search_condition.created_to
				}

				// 기간 toggle
				if (this.$route.query.toggle) {
					this.selection_period.toggle = this.$route.query.toggle
				}
			},
			searchList() {
				this.selection_period = this.$refs.datepick.getDate()


				// 날짜 변환
				this.search_condition.created_from = this.selection_period.from
				this.search_condition.created_to = this.selection_period.to

				// 기본정보
				let query = {}

				// ID
				if (this.search_condition.user_id) {
					query.user_id = this.search_condition.user_id
				}

				// 닉네임
				if (this.search_condition.nickname) {
					query.nickname = this.search_condition.nickname
				}

				// 이메일
				if (this.search_condition.email) {
					query.email = this.search_condition.email
				}

				// 타입
				if (this.search_condition.type) {
					query.type = this.search_condition.type
				}

				// sns타입
				if (this.search_condition.sns_type) {
					query.sns_type = this.search_condition.sns_type
				}


				// 등록일(from)
				if (this.search_condition.created_from) {
					query.created_from = this.search_condition.created_from
				}

				// 등록일(to)
				if (this.search_condition.created_to) {
					query.created_to = this.search_condition.created_to
				}

				// 기간 toggle
				if (this.selection_period.toggle) {
					query.toggle = this.selection_period.toggle
				}


				// 페이지 호출 (with query)
				if (query) {
					this.$router.push({path: 'users', query})
				} else {
					this.$router.push({path: 'users'})
				}
			},

			/////////////////////////////////////////////////// REQ /////////////////////////////////////////////////////////

			reqList(req) {
				this.routeCheck()

				if (req != null) {
					Object.keys(req).forEach((key) => (req[key] == null || req[key] == '') && delete req[key])
				}


				return userApi.retrieveUsers(req).then(res => {
					this.items = res.data
					this.total = this.items.length
				}).catch(e=>{
					this.$dialog.alert(e.message)
				})
			},

		}

	}
</script>

